export default __webpack_public_path__ + "static/media/LeftArrowWhite.4b1e99c7.svg";